<template>
    <div class="acomodar">
        <Visualizador/>
        
    </div>
</template>

<script>
import Visualizador from '@/components/ModSeleccion/Acceso/VisualizarAcceso.vue'
import '@/assets/styles/global-acomodar.css'; // Importar el estilo global
export default {
    name: 'SolimanologAccesoVisualizar',
    components:{
        Visualizador
    },

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

